import React from 'react'
import * as yup from 'yup'
import { ApplicationFormAnswers } from '../components/ApplicationForm/ApplicationFormContext'
import BaseValidator from './BaseValidator'
import { muiColors } from '@zuto/theme/src/mui/DefaultTheme'
import { Link } from '@mui/material'


const regExpStr = 
  "^(?!.*\\.\\.)(?!.*\\.$)(?!^\\.)" + // Prevents double dots and dot at the start or end
  "(" + // Local part
    "([\\w!#$%&'*+/=?^`{|}~-]+" + // One or more characters that are allowed in the local part
    "|\"([^\"]|\\\\.)*\")" + // Or quoted string
    "(?:\\.[\\w!#$%&'*+/=?^`{|}~-]+|\"([^\"]|\\\\.)*\")*" + // Allow dots in the local part as long as they are not consecutive or at the start/end
  ")" + 
  "@" + // At symbol
  "(?![0-9]+$)" + // Assert that the domain part is not numeric only
  "([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)" + // Domain part: 1-63 characters, no leading or trailing hyphen
  "(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*" + // Optional subdomains with the same rules
  "\\.[a-zA-Z]{2,}$" // Top-level domain with at least two alphabetic characters



const emailRegex: RegExp = new RegExp(regExpStr)


const EmailAddressValidatorLookupService = (emailValidationError?: string): BaseValidator => {
  const schema = yup.object().shape({
    emailAddress: yup.string()
      .required('Please enter your email address')
      .matches(emailRegex, 'Please enter a valid email address')
      .label('Email address')
      .max(100)
      .when([], {
        is: () => !!emailValidationError,
        then: yup.string().test('error-check', emailValidationError as string, () => false)
      })
  })

  return {
    getValidator: () => schema as yup.BaseSchema,
    validateState: (state: ApplicationFormAnswers) => schema.isValidSync({
      emailAddress: state.personalDetails?.emailAddress
    })
  }
}

type FieldKey = "emailAddress"

const extractEmailParts = (message: string): { email: string, beforeEmail: string } => {
  // Reverse string and find the substring between `?` and the first space
  const reversedMessage = message.split('').reverse().join('')
  const reversedEmail = reversedMessage.split('?')[1].split(' ')[0]
  // Reverse back and find substring with email
  const email = reversedEmail.split('').reverse().join('')
  const beforeEmail = message.split(email)[0]
  return { email, beforeEmail }
}

const displayClickableEmail = (
  message:string, 
  onChange: (key: FieldKey, value: string) => void
): JSX.Element => {
  if (!message.includes('@')) return <span>{message}</span>
  const { email, beforeEmail } = extractEmailParts(message)
  return (
    <span>
      {beforeEmail} 
      <Link 
        sx={{color: muiColors.primary.blueMain, textDecoration: 'none' ,cursor: 'pointer'}} 
        onClick={() => onChange('emailAddress', email)}>
          {email}
      </Link>?
    </span>
  )
}

export {
  EmailAddressValidatorLookupService,
  displayClickableEmail,
  extractEmailParts
}
